(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@aws-amplify/core"), require("@aws-amplify/cache"));
	else if(typeof define === 'function' && define.amd)
		define("aws_amplify_analytics", ["@aws-amplify/core", "@aws-amplify/cache"], factory);
	else if(typeof exports === 'object')
		exports["aws_amplify_analytics"] = factory(require("@aws-amplify/core"), require("@aws-amplify/cache"));
	else
		root["aws_amplify_analytics"] = factory(root["@aws-amplify/core"], root["@aws-amplify/cache"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__8__) {
return 